export *                      from './device-beacon.class';

export *                      from './device-beacon-info.component';

export { DeviceBeaconCommon } from '@Common/';